export function initializeSelect2(selector = '.select2bs4') {
  $(selector).select2({
    theme: 'bootstrap4',
    allowClear: true,
    placeholder: function () {
      return $(this).data('placeholder');
    }
  });
}

export function destroySelect2(selector = '.select2bs4') {
  $(selector).select2('destroy');
}
